import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../i18n';
import {mapDispatchToProps} from "../mapDispatchToProps"

class ErrorOauthAuthorize extends React.Component {
  componentDidMount() {
    localStorage.removeItem('oauth_authorize');
  }

  render() {
    return (
      <div className="login-container">
        <div className="text-center login-block">
          <p className="line1">{i18n.t("oauth_authorize.authorize.title")}</p>
          <p className="text-center line2 text-danger">{i18n.t("oauth_authorize.authorize.error")}</p>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorOauthAuthorize)